export default "__VITE_ASSET__C7UX5pZZ__"